import {LayoutComponent} from "../layout/layout.component";
import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {RegistrationComponent} from "./registration.component";

const routes: Routes = [
  {
    path: 'registration',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: RegistrationComponent,
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RegistrationRoutingModule { }
